import {
  Form,
  Input,
  InputNumber,
  Button,
  Layout,
  Select,
  Switch,
  Typography,
  notification,
  Row,
  Col,
  Divider,
} from 'antd';
import {CopyFilled} from '@ant-design/icons';
import "./Config.css"
import {useState} from "react";

const {Paragraph} = Typography;
const {Header, Footer, Content} = Layout;

const layout = {
  labelCol: {span: 8},
  wrapperCol: {span: 10},
};

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '${label} 是必填字段!',
  types: {
    email: '${label} 不是一个合法的邮箱地址!',
    number: '${label} 不是一个合法数字!',
  },
  number: {
    range: '${label} 需要在 ${min} 和 ${max} 之间!',
  },
};
/* eslint-enable no-template-curly-in-string */
const TCP = 1
const SSL = 2
const MinerPoolAddrs = [
  {addr: "raven.f2pool.com:3636", classify: "rvn", type: TCP},
  {addr: "etc.f2pool.com:8118", classify: "etc", type: TCP},
  {addr: "cfx.f2pool.com:6800", classify: "cfx", type: TCP},
  {addr: "stratum-ravencoin.flypool.org:3333", classify: "rvn", type: TCP},
  {addr: "stratum-ravencoin.flypool.org:13333", classify: "rvn", type: TCP},
  {addr: "stratum-ravencoin.flypool.org:3443", classify: "rvn", type: SSL},
  {addr: "stratum-ergo.flypool.org:3333", classify: "ego", type: TCP},
  {addr: "stratum-ergo.flypool.org:13333", classify: "ego", type: TCP},
  {addr: "stratum-ergo.flypool.org:3443", classify: "ego", type: SSL},
  {addr: "asia1-etc.ethermine.org:4444", classify: "etc", type: TCP},
  {addr: "asia1-etc.ethermine.org:14444", classify: "etc", type: TCP},
  {addr: "asia1-etc.ethermine.org:5555", classify: "etc", type: SSL},
  {addr: "rvn.666pool.com:6688", classify: "rvn", type: TCP},
  {addr: "cfx.666pool.com:6655", classify: "cfx", type: TCP},
  {addr: "ergo.666pool.com:9556", classify: "ego", type: TCP},
  {addr: "ergo.666pool.com:9558", classify: "ego", type: SSL},
  {addr: "etc.666pool.com:8336", classify: "etc", type: TCP},
  {addr: "eth-hke.flexpool.io:13271", classify: "eth", type: TCP},
  {addr: "eth-hk.flexpool.io:13271", classify: "eth", type: TCP},
  {addr: "eth-hke.flexpool.io:22271", classify: "eth", type: SSL},
  {addr: "eth-hk.flexpool.io:22271", classify: "eth", type: TCP},
  {addr: "asia1.ethermine.org:4444", classify: "eth", type: TCP},
  {addr: "asia2.ethermine.org:4444", classify: "eth", type: TCP},
  {addr: "asia1.ethermine.org:5555", classify: "eth", type: SSL},
  {addr: "asia2.ethermine.org:5555", classify: "eth", type: SSL},
  {addr: "eth.ss.poolin.me:443", classify: "eth", type: TCP},
  {addr: "eth.ss.poolin.me:1883", classify: "eth", type: TCP},
  {addr: "eth.ss.poolin.me:700", classify: "eth", type: TCP},
  {addr: "eth.f2pool.com:6688", classify: "eth", type: TCP},
  {addr: "eth-backup.f2pool.com:6688", classify: "eth", type: TCP},
  {addr: "stratum-eth.antpool.com:8008", classify: "eth", type: TCP},
  {addr: "stratum-eth.antpool.com:25", classify: "eth", type: TCP},
  {addr: "stratum-eth.antpool.com:443", classify: "eth", type: TCP},
]


const minerPoolMap: Record<string, 1 | 2> = MinerPoolAddrs.reduce((acc, v) => {
  return {
    ...acc, [v.addr]: v.type
  }
}, {})

const PoolSelector = (props: { pools: Array<{ addr: string, type: number }>, [key: string]: any }) => (<>
    <Select {...props} allowClear={true} placeholder={props.pools.length >0? "选择矿池地址后将会自动匹配连接方式（TCP/SSL)":"请先选择代币类型"}>
      {props.pools.map(v => <Select.Option key={v.addr}
                                           value={v.addr}>{`(${v.type === SSL ? 'SSL' : 'TCP'}) ${v.addr}`}</Select.Option>)}
    </Select>
  </>
)

interface IConfig {
  ip?: string
  port: number
  remotePoolAddr: string
  enableClientSSL?: boolean
  devFeeRate: number
  devFeeRemoteAddr?: string
  enableRemoteSSL?: boolean
  enableDevFeeSSL?: boolean
  ethWalletAddr: string
  kernelConfig?: string
  coinType: string
}

export const Config = () => {
    const [enableAdvanceConfig, setEnableAdvanceConfig] = useState<boolean>(false)
    const [config, setConfig] = useState<string>("")
    const [formData, setFormData] = useState<IConfig>()
    const [form] = Form.useForm();
    const onFinish = (values: IConfig) => {
      let config = "chmod u+x ./tax.miner.proxy && ./tax.miner.proxy "
      if (values.port) {
        config += ` -l :${values.port}`
      }
      if (values.enableClientSSL) {
        config += ` -enable_client_ssl`
        notification.info({
          message: '启用 SSL 连接',
          description: <>
            目前配置代理已经启用 SSL 监听本地端口 {values.port}，请确保内核侧同时已经正确启用 SSL，否则会无法进行正常通信。
          </>,
        });
      } else {
        notification.info({
          message: '未启用 SSL 连接',
          description: <>
            目前配置代理禁用 SSL 监听本地端口 {values.port}，在当前特殊的互联网时期可能会有安全风险。
            请确保内核侧同时已经正确禁用 SSL，否则会无法进行正常通信
          </>,
        });
      }
      if (values.remotePoolAddr) {
        config += ` -r ${values.remotePoolAddr.trim()}`
        if (!minerPoolMap[values.remotePoolAddr.trim()] && values.enableRemoteSSL) {
          config += ` -enable_server_ssl`
        }
      }
      if (values.devFeeRemoteAddr) {
        config += ` -devfee_addr ${values.devFeeRemoteAddr.trim()}`
        if (!minerPoolMap[values.devFeeRemoteAddr.trim()] && values.enableDevFeeSSL) {
          config += ` -enable_devfee_ssl`
        }
      }
      if (values.coinType) {
        config +=` -coin_type ${values.coinType}`
      }
      if (values.ethWalletAddr) {
        config += ` -wallet ${values.ethWalletAddr}`
      }
      if (values.ethWalletAddr || values.devFeeRate) {
        config += ` -devfee_rate ${values.devFeeRate || 0}`
      }
      if (!values.ethWalletAddr) {
        notification.info({
          message: '纯转发模式',
          description: <>
            当前未进程抽水配置，将使用纯转发模式
          </>,
        });
      }
      //
      // if (values.kernelConfig) {
      //   const enableTCP = /tcp/.test(`${values.kernelConfig}`.toLowerCase())
      //   if (values.enableClientSSL && enableTCP) {
      //     notification.warning({
      //       message: '配置冲突警告',
      //       description: <>
      //         在内核配置中发现连接方式与代理监听方式可能有差异,
      //         目前代理监听方式为 ${values.enableClientSSL ? "SSL" : "TCP"}，
      //         请务必确认内核是以相同的协议与代理通信。
      //         如完成确认，请忽略此消息
      //       </>,
      //     });
      //   }
      // } else {
      //   notification.warning({
      //     message: '无法验证配置',
      //     description: <>
      //       请尽量提供下内核启动参数，方便工具进行参数可用性的初步验证
      //     </>,
      //   });
      notification.success({
        message: '生成成功',
        description: <>
          代理启动参数生成成功，请结合代理使用说明检查配置是否正确
          工具生成配置仅做参考使用，请点击下方 <CopyFilled key="copy-icon"/> 进行复制。
          如有疑问，请联系 Tax Miner Proxy开发者
        </>,
      });
      setConfig(config)
      // }
    }
    const onConfigModeChange = (checked: boolean) => {
      form.resetFields()
      setEnableAdvanceConfig(checked)
    }
    return (
      <Layout className={"container"}>
        <Header className="header" style={{fontWeight: "bold", fontSize: "1.2em"}}> TAX Miner Proxy</Header>
        <Content>
          <Typography.Title className="form-title"><Typography.Link href="https://github.com/tax0x7e7/tax_miner_proxy"
                                                                    target="_blank" rel="noopener noreferrer">Tax
            Miner Proxy</Typography.Link> 启动配置生成器</Typography.Title>
          {/*<Row>*/}
          {/*  <Col span={18}>*/}
          <Form
            className="config-from"
            {...layout}
            form={form}
            name="nest-messages" onFinish={onFinish}
            validateMessages={validateMessages} onFieldsChange={() => {
            setFormData(form.getFieldsValue())
            // onFinish(form.getFieldsValue())
            setConfig("")
          }}>
            <Form.Item name={['enableAdvanceConfigMode']} label="高级配置模式">
              <Switch checked={enableAdvanceConfig} onChange={onConfigModeChange}/>
            </Form.Item>
            <Form.Item name={['coinType']} label={"代币类型"} rules={[{required: true}]}>
              <Select placeholder={"请选择代币类型"} onChange={(() => {
                form.resetFields(["remotePoolAddr","ethWalletAddr","devFeeRemoteAddr"])
              })}>
                {["eth", "etc", "rvn", "cfx", "ego"].map(v => <Select.Option key={v}
                                                                             value={v}>{v.toUpperCase()}</Select.Option>)}
              </Select>
            </Form.Item>
            <Form.Item name={['remotePoolAddr']} label="转发矿池地址" rules={[{required: true}]}>
              {enableAdvanceConfig ?
                <Input placeholder={`请填写矿池地址，例如：asia2.ethermine.org:5555`}/> :
                <PoolSelector pools={MinerPoolAddrs.filter(v => v.classify === formData?.coinType)}/>}
            </Form.Item>
            {enableAdvanceConfig && !minerPoolMap[`${formData?.remotePoolAddr}`] &&
                <Form.Item name={['enableRemoteSSL']} label="转发矿池SSL连接" rules={[{required: false}]}>
                    <Switch/>
                </Form.Item>}
            {/*<Form.Item name={['ip']} label="代理服务器地址" rules={[{required: false}]}>*/}
            {/*  <Input placeholder={"当填入内核配置时，可以对内核配置进行校验"}/>*/}
            {/*</Form.Item>*/}
            <Form.Item name={['port']} label="代理监听端口"
                       rules={[{required: true}, {type: 'number', min: 0, max: 65535}]}>
              <InputNumber/>
            </Form.Item>
            <Form.Item name={['enableClientSSL']} label="矿机连接模式" rules={[{required: false}]}>
              <Switch checkedChildren="SSL" unCheckedChildren="TCP"/>
            </Form.Item>
            <Form.Item name={['ethWalletAddr']} label="抽水 Eth 钱包地址" rules={[
              {required: false}]}>
              <Input placeholder={"抽水钱包地址，请务必确认和代币类型一致"}/>
            </Form.Item>
            {formData?.ethWalletAddr && <>
                <Form.Item name={['devFeeRemoteAddr']} label="抽水矿池地址" rules={[{required: !!formData.ethWalletAddr}]}>
                  {enableAdvanceConfig ? <Input/> :
                    <PoolSelector pools={MinerPoolAddrs.filter(v => v.classify === formData?.coinType)}/>
                  }
                </Form.Item>
              {enableAdvanceConfig && !minerPoolMap[`${formData?.devFeeRemoteAddr}`] &&
                  <Form.Item name={['enableDevFeeSSL']} label="抽水矿池SSL连接" rules={[{required: false}]}>
                      <Switch/>
                  </Form.Item>}
                <Form.Item name={['devFeeRate']} label="抽水比例(%)" rules={[{type: 'number', min: 0, max: 100}]}>
                    <InputNumber/>
                </Form.Item>
            </>}
            {/*<Form.Item name={['kernelConfig']} label="挖矿内核配置">*/}
            {/*  <Input.TextArea placeholder={"填写挖矿内核的配置信息，工具会对生成的信息进行检查"}/>*/}
            {/*</Form.Item>*/}
            <Form.Item wrapperCol={{...layout.wrapperCol, offset: 8}}>
              <Button type="primary" htmlType="submit">
                生成配置
              </Button>
            </Form.Item>
          </Form>
          {/*</Col>*/}
          {/*<Col span={4}>*/}
          {/*  <Typography>*/}
          {/*    <Typography.Title level={2}> Tax Miner Proxy</Typography.Title>*/}
          {/*  </Typography>*/}
          {/*</Col>*/}
          {/*</Row>*/}
          <Divider/>
          <Row>
            <Col offset={2} span={20}>
              {config && <Paragraph
                  copyable={{
                    // icon: [<SmileOutlined key="copy-icon"/>, <SmileFilled key="copied-icon"/>],
                    tooltips: ['点击复制', '复制成功'],
                  }}
              >
                {config}
              </Paragraph>}
            </Col>
          </Row>

        </Content>
        <Footer className="footer"> CopyRight @ Tax Miner Proxy Developer Group. All Right Reserved</Footer>
      </Layout>
    )
      ;
  }
;